import { useEffect, useState } from 'react';

// A component that delays rendering for the specified time in miliseconds.
const Delayed = ({ delay, children }) => {
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => setShowContent(true), delay);
    return () => clearTimeout(timeoutId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return showContent && children;
};

export default Delayed;
